module.exports = __webpack_public_path__ + "img/berechnung_leg.eac7e8cb.jpg";